export type Price = {
  id: number;
  stripeId: string;
  nickname: string | null;
  unitAmount: number | null;
};
export type Product = {
  id: number;
  stripeId: string;
  name: string;
  description: string;
  active: boolean;
  prices: Price[];
};

export enum CardBrand {
  // LIES
  // https://stripe.com/docs/api/cards/object
  AmericanExpress = "amex",
  DinersClub = "diners",
  Discover = "discover",
  JCB = "jcb",
  MasterCard = "mastercard",
  UnionPay = "unionpay",
  Visa = "visa",
  Unknown = "unknown",
}

export type PaymentMethod = {
  id: number;
  card: {
    brand: CardBrand;
    last4: string;
  };
};

export type Subscription = {
  id: number;
  defaultPaymentMethod: PaymentMethod;
  items: {
    subscription: string;
    price: string;
  }[];
  currentPeriodEnd: Date;
  status: string;
};

export type Invoice = {
  id: number;
  subscription: string;
  periodStart: Date;
  periodEnd: Date;
  total: number;
  amountPaid: number;
  paid: boolean;
  invoicePdfLink: string;
};

export enum Tier {
  Free = "free",
  Pro = "pro",
  Payg = "payg",
  Enterprise = "enterprise",
}

export enum ProgramUtilization {
  ReachedQuota = 100,
  High = 90,
  Medium = 75,
  Low = 50,
}
